'use client';
/**
 * Fires a Impression Ready event for Google Analytics. *Note: Do not ever push PII into the data layer!!*
 *
 * @example
 * const { fireEvent } = useImpressionReadyEvent();
 * fireEvent(items);
 */
import { useCallback } from 'react';
import { sendGTMEvent } from '@next/third-parties/google';
import { getValueOrElseEmptyString } from 'utils/string';
import {
  OrderDetailsItem,
  ItemPrice
} from 'services/order/types';
import {
  CHECKFITMENT,
  DEFAULT_BRAND,
  DEFAULT_BUSINESS_UNIT,
  VIEW_ITEM_LIST_EVENT
} from 'constants/analyticsConstants';
import { LineItem } from 'types/parts-diagram';
type ViewItemListType = {
  products: OrderDetailsItem[] | LineItem[] | { [key: string]: unknown }[];
  cartId?: string;
  currency?: string;
  dealerId?: string | number;
  model?: string;
  paymentMethods?: string[];
  selectedEquipment?: Pick<Equipment, 'model'>;
  storeName: string;
  list: string;
};
export const useImpressionReadyEvent = () => {
  
  const buildEvent = useCallback(
    ({
      cartId,
      currency,
      dealerId,
      model,
      paymentMethods,
      products,
      selectedEquipment,
      storeName,
      list
    }: ViewItemListType) => {
      const cartDetails = {
        cartId: cartId || undefined,
      };
      const items = products?.map((product, index) => {
        const priceWithoutGST = product.priceWithoutGST as ItemPrice;
        return {
          item_id: getValueOrElseEmptyString(product.partNumber),
          item_name: getValueOrElseEmptyString(product.name ?? product.description),
          affiliation: DEFAULT_BUSINESS_UNIT,
          coupon: undefined,
          discount: undefined,
          index: index + 1,
          item_brand: DEFAULT_BRAND,
          item_category: product.category ,
          item_category2: undefined,
          item_category3: undefined,
          item_category4: undefined,
          item_category5: undefined,
          item_variant: undefined,
          item_list_id:getValueOrElseEmptyString(list),
          item_list_name:getValueOrElseEmptyString(list),
          location_id: undefined,
          price: priceWithoutGST?.formatted?.totalPrice,
          quantity: product.quantity,          
          p_inventory_status: undefined,
          p_weight: product.weight,
          p_serial_number: undefined,
          p_kit_id: product.kitId,
          p_check_fitment: CHECKFITMENT,
          p_attributes_visible: product.productAttributesVisible
          
        };
        
      });
      return {
        event: VIEW_ITEM_LIST_EVENT,
        cartDetails,
        ecommerce: {
          item_list_id:getValueOrElseEmptyString(list),
          item_list_name:getValueOrElseEmptyString(list),
          currency: currency,
          items
        }
        
      };
    },
    []
  );
  const fireEvent = useCallback(
    (data: ViewItemListType) => sendGTMEvent(buildEvent(data)),
    [buildEvent]
  );
  return { fireEvent };
};